import {
  Button,
  DateText,
  EmptyState,
  IconButton,
  Loader,
  Panel,
  Table,
  Text,
} from "@coaching-culture/ui";
import axios from "axios";
import CenterColumn from "components/CenterColumn";
import React, { useEffect, useState } from "react";
import { FaPlusCircle, FaTimes, FaWpforms } from "react-icons/fa";
import { Link } from "react-router-dom";
import { PageHeader } from "components/PageHeader";

const SelfReg = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get("/api/self-registration-forms").then(({ data }) => {
      setItems(data);
    });
  }, []);

  const loading = items == null;

  const deleteItem = (id) => {
    if (window.confirm("Are you sure you want to delete this form?")) {
      axios.delete(`/api/self-registration-forms/${id}`).then(() => {
        setItems((old) => old.filter((x) => x.url !== id));
      });
    }
  };

  return (
    <CenterColumn>
      <PageHeader
        text="Self Registration"
        subtitle="Manage your self registration forms"
      >
        <Button
          to="/success/people/self-registration/create"
          icon={FaPlusCircle}
          variant="primary"
        >
          Create Form
        </Button>
      </PageHeader>
      <Text fontWeight={600} mb={2}>
        Self Registration Forms
      </Text>
      <Panel>
        {loading ? (
          <Loader />
        ) : items.length === 0 ? (
          <EmptyState compact icon={FaWpforms}>
            No self registration forms have been created yet.
          </EmptyState>
        ) : (
          <>
            <Table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Created</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {items.map((x) => (
                  <tr>
                    <td>
                      <Text fontWeight={600}>
                        <Link to={`/success/people/self-registration/${x.url}`}>
                          {x.name}
                        </Link>
                      </Text>
                    </td>
                    <td>
                      <DateText value={new Date(x.createdOn)} />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <IconButton
                        icon={FaTimes}
                        color="danger"
                        onClick={() => deleteItem(x.url)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Panel>
    </CenterColumn>
  );
};

export default SelfReg;
